import { HttpContextToken } from '@angular/common/http';

/**
 * When true, auth interceptor skips the global MatSnackBar error toast.
 * Used for background notification badge / pending-work polls that must not
 * spam the UI (or leave Material overlay debris) on transient network errors.
 */
export const SILENT_HTTP = new HttpContextToken<boolean>(() => false);
